import {
  Hash,
  BarChart3,
  LineChart as LineIcon,
  PieChart as PieIcon,
  Table,
  Type,
  CalendarDays,
  Columns3,
  ListChecks,
  LayoutGrid,
  Image as ImageIcon,
  Sparkles,
} from "lucide-react";
import type { WidgetType } from "./types";
import { useTranslation } from "../../i18n";

const ITEMS: { type: WidgetType; key: string; label: string; icon: React.ReactNode }[] = [
  { type: "metric", key: "widget.metricCard", label: "Metric Card", icon: <Hash size={18} /> },
  { type: "kpi_row", key: "widget.kpiRow", label: "KPI Row", icon: <LayoutGrid size={18} /> },
  { type: "bar", key: "widget.barChart", label: "Bar Chart", icon: <BarChart3 size={18} /> },
  { type: "line", key: "widget.lineChart", label: "Line Chart", icon: <LineIcon size={18} /> },
  { type: "pie", key: "widget.pieDonut", label: "Pie / Donut", icon: <PieIcon size={18} /> },
  { type: "table", key: "widget.dataTable", label: "Data Table", icon: <Table size={18} /> },
  { type: "day_of_week", key: "widget.dayOfWeek", label: "Day of Week", icon: <CalendarDays size={18} /> },
  { type: "comparison", key: "widget.comparison", label: "Comparison", icon: <Columns3 size={18} /> },
  { type: "status_table", key: "widget.rankedTable", label: "Ranked Table", icon: <ListChecks size={18} /> },
  { type: "text", key: "widget.textBlock", label: "Text Block", icon: <Type size={18} /> },
  { type: "image", key: "widget.image", label: "Image", icon: <ImageIcon size={18} /> },
  { type: "ai_summary", key: "widget.aiSummary", label: "AI Summary", icon: <Sparkles size={18} /> },
];

export function WidgetToolbar({ onAdd }: { onAdd: (type: WidgetType) => void }) {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6">
      {ITEMS.map((it) => (
        <button
          key={it.type}
          onClick={() => onAdd(it.type)}
          className="flex flex-col items-center gap-1.5 rounded-xl border border-gray-200 bg-white px-2 py-3 text-center text-xs font-medium text-gray-700 shadow-sm transition hover:border-blue-300 hover:bg-blue-50 hover:text-blue-900"
        >
          <span className="text-gray-500">{it.icon}</span>
          {t(it.key, it.label)}
        </button>
      ))}
    </div>
  );
}
